export const sortingStarted = () => {
    return {
        type: 'STARTED'
    }
};

export const sortingContinued = () => {
    return {
        type: 'CONTINUED'
    }
};

export const sortingPaused = () => {
    return {
        type: 'PAUSED'
    }
};

export const sortingStopped = () => {
    return {
        type: 'STOPPED'
    }
};

export const sortingCompleted = () => {
    return {
        type: 'COMPLETED'
    }
}

export const sortingRefresh = () => {
    return {
        type: 'REFRESH'
    }
}